// A parentID gyerekei közül összegyűjti azokat, amelyek trigger_on-ja
// tartalmazza a szülő aktuális válaszát, majd rekurzívan azok gyerekeit is.
// Az answerOf adja az al-kérdés válaszát, így a még el nem mentett (vagy az
// eredeti) válasszal is számolható a láthatóság.
const collectVisibleSubQuestions = (subQuestions, parentID, parentAnswers, depth, visible, answerOf) => {
  for (const subQuestion of subQuestions) {
    const isChildOfParent = parentID === null
      ? (subQuestion.parent_id === null || subQuestion.parent_id === undefined)
      : Number(subQuestion.parent_id) === Number(parentID)
    if (!isChildOfParent) {
      continue
    }
    const isTriggered = (subQuestion.trigger_on || []).some(
      triggerValue => parentAnswers.some(answerValue => Number(answerValue) === Number(triggerValue)))
    if (!isTriggered) {
      continue
    }
    visible.push({ subQuestion, depth })
    const answer = answerOf(subQuestion)
    const subQuestionAnswers = subQuestion.type === 'checkbox'
      ? (answer || [])
      : (answer === null || answer === undefined ? [] : [answer])
    collectVisibleSubQuestions(subQuestions, subQuestion.id, subQuestionAnswers, depth + 1, visible, answerOf)
  }
}

// A főkérdés answer válaszánál látható al-kérdések { subQuestion, depth } formában.
export const getVisibleSubQuestions = (subQuestions, answer, answerOf = subQuestion => subQuestion.answer) => {
  const visible = []
  collectVisibleSubQuestions(subQuestions, null, [answer], 0, visible, answerOf)
  return visible
}

export const isSubQuestionAnswered = (subQuestion, answer) => {
  if (subQuestion.type === 'checkbox') {
    return (answer || []).length >= (subQuestion.min_selected || 0)
  }
  return answer !== null && answer !== undefined
}

// A backend a sub_question_answer_items-et a sub_question_answer alatt tárolja,
// ezért a kettőt mindig együtt, a teljes aktuális állapottal kell elküldeni –
// különben a nem módosított fél törlődik. A láthatóságot az answer és az
// answerOf szerinti állapotra számoljuk: ami nincs triggerelve, annak a
// válasza szándékosan kimarad (a select átállításakor a hozzá tartozó checkbox törlődik).
export const getSubQuestionAnswerPayload = (subQuestions, answer, answerOf) => {
  let subQuestionAnswer = null
  let subQuestionAnswerItems = null
  for (const { subQuestion } of getVisibleSubQuestions(subQuestions, answer, answerOf)) {
    const subQuestionAnswerValue = answerOf(subQuestion)
    if (subQuestion.type === 'checkbox') {
      subQuestionAnswerItems = subQuestionAnswerValue || []
    } else if (subQuestionAnswerValue !== null && subQuestionAnswerValue !== undefined) {
      subQuestionAnswer = subQuestionAnswerValue
    }
  }
  return { subQuestionAnswer, subQuestionAnswerItems }
}
